let initialState = {
    settings: {},
    globalSpinner: true,
    rightBasketModal: false,
    menuData: {
        leftMenuVisible: false,
        lists: [
            {
                title: 'ANA SAYFA',
                id: 'home',
                to: '/home',
            },
            {
                title: 'ÜRÜNLER',
                id: 'category',
                to: '/kategori/daily/temel-bakim',
            },
            {
                title: 'KAMPANYALAR',
                id: 'campaign',
                to: '/kampanyalar/guncel-kampanyalar',
            },
            {
                title: 'YETKİLİ ECZANELER',
                id: 'authorized_pharmacies',
                to: '/yetkili-eczaneler',
            },
            {
                title: 'DOKÜMANLAR',
                id: 'archive',
                to: '/dokumanlar',
            },
            {
                title: 'SHINIQ DÜNYASI',
                id: 'shiniq_world',
                to: '/dokumanlar',
            },
        ],
    },
}

export default function GeneralReducer(state = initialState, action) {
    if (action.type === 'setGlobalSpinner') {
        return Object.assign({}, state, {globalSpinner: action.payload.globalSpinner})
    } else if (action.type === 'setMenuData') {
        return Object.assign({}, state, {menuData: action.payload.menuData})
    } else if (action.type === 'setGlobalConfiguration') {
        return Object.assign({}, state, {settings: action.payload.settings})
    } else {
        return state
    }
}
